import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

interface ContractorSkeletonProps {
  viewMode?: "grid" | "list";
}

export const ContractorSkeleton = ({ viewMode = "grid" }: ContractorSkeletonProps) => {
  return (
    <Card className={`overflow-hidden ${
      viewMode === "grid" ? 'flex flex-col' : 'flex flex-row'
    }`}>
      <div className={`relative ${
        viewMode === "grid" 
          ? "aspect-[16/9] w-full" 
          : "w-48 aspect-[4/3]"
      }`}>
        <Skeleton className="absolute inset-0" />
      </div>
      
      <div className="p-6 space-y-4 flex-1">
        <div className="space-y-2">
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
        
        <div className="flex items-center gap-2">
          <Skeleton className="h-5 w-5 rounded-full" />
          <Skeleton className="h-4 w-16" />
        </div>
        
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      </div>
    </Card>
  );
};